import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import {
  MainContainer,
  ContentContainer,
  PageTitle,
  LinkContainer,
  LinkSpace,
} from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import { ACCOUNT_GROUPS, HIDE_ACCOUNT_GROUP } from './queries';
import SubNav from './SubNav';
import EditAccountGroup from './edit';

const baseColumns = [
  {
    key: 'name',
    label: 'Name',
    sort: 'asc',
  },
  {
    key: 'type',
    label: 'Type',
  },
];

const AccountGroups = () => {
  const [showEditModal, setShowEditModal] = useState();
  const { currentUser } = useContext(AuthContext);

  const { data, refetch } = useQuery(ACCOUNT_GROUPS);

  const [hideAccountGroup] = useMutation(
    HIDE_ACCOUNT_GROUP, { onCompleted: refetch }
  );

  if (!data) { return <DataState.Loading /> };

  const onHide = accountGroup => {
    if (window.confirm(`Hide ${accountGroup.name}?`)) {
      hideAccountGroup({ variables: { id: accountGroup.id }});
    }
  };

  const columns = [
    ...baseColumns,
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: ({ entry }) => (
        <LinkContainer>
          <Pressable onPress={() => setShowEditModal(entry)}>
            <Text>Edit</Text>
          </Pressable>
          <LinkSpace />
          {currentUser?.accounting && (
            <Pressable onPress={() => onHide(entry)} >
              <Text>Hide</Text>
            </Pressable>
          )}
        </LinkContainer>
      )
    },
  ];

  return (
    <MainContainer>
      <SubNav refetch={refetch} />

      <ContentContainer>
        <PageTitle>Account Groups</PageTitle>

        <DataTable.Simple
          data={data.accountGroups}
          columns={columns}
        />
      </ContentContainer>

      {showEditModal &&
        <Modal
          showModal
          setShowModal={setShowEditModal}
          modalType="Edit Account Group"
        >
          <EditAccountGroup
            accountGroup={showEditModal}
            setShowModal={setShowEditModal}
            refetch={refetch}
          />
        </Modal>
      }
    </MainContainer>
  );
};

export default AccountGroups;
